import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import AdminHome from "./Routes/Home/Home";
import Applicant from "./Routes/Home/Applicant";

import AdminLogin from "./Routes/Login/AdminLogin";
import Users from "./Routes/Users/Users";
import UserInfo from "./Routes/Users/UserInfo";
import Doctors from "./Routes/Doctors/Doctors";
import PageRoute from "./Components/Utils/PageRoutes";
import Department from "./Routes/Departments/Department";

export default class Admin extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={PageRoute.home} component={AdminHome} />
        <Route path={PageRoute.login} component={AdminLogin} />
        <Route exact path={PageRoute.users} component={Users} />
        <Route path={PageRoute.userinfo} component={UserInfo} />
        <Route path={PageRoute.doctors} component={Doctors} />
        <Route path={PageRoute.department} component={Department} />
        <Route path={PageRoute.applicant} component={Applicant} />
        {/*<Route path="/admin/users" component={About}/>
          <Route path="/admin/doctors" component={TnC}/>
            <Route path="/admin/newdoctors" component={Solution}/>*/}
      </Switch>
    );
  }
}
